import React, { useContext } from "react";
import styles from "./CarrinhoItem.module.scss";
import { formatarMoeda } from "shared/utils/money";
import { CartContext } from "shared/contexts/Cart/CartContext";
import { CartProps } from "shared/interfaces/ICart";
import { MinusSquare, PlusSquare, Trash2 } from "lucide-react";
import { textoVariacoes } from "shared/utils/carrinho";

interface Props {
  item: CartProps;
}

const MOTIVOS_INDISPONIVEL: Record<string, string> = {
  INSUFFICIENT_STOCK: "Estoque insuficiente para esta quantidade",
  COMBINATION_NOT_AVAILABLE: "Esta opção não está mais à venda",
  VARIATION_REQUIRED: "Escolha as opções do produto novamente",
  PRODUCT_NOT_FOUND: "Produto indisponível",
};

export const CarrinhoItem: React.FC<Props> = ({ item }) => {
  const { increaseItem, decreaseItem, removeItemCart } = useContext(CartContext);
  const limiteAtingido = item.unidades >= item.estoque;

  return (
    <section className={styles.item}>
      {/* IMAGEM */}
      <div className={styles.imgItem}>
        <img src={item.gallery || "/imagens/default.png"} alt={item.name} />
      </div>

      {/* INFO */}
      <div className={styles.info}>
        <p className={styles.nomeProduto}>{item.name}</p>

        {textoVariacoes(item) && <p className={styles.variacoes}>{textoVariacoes(item)}</p>}

        {item.motivoIndisponivel && (
          <p className={styles.indisponivel}>
            {MOTIVOS_INDISPONIVEL[item.motivoIndisponivel] ?? "Item indisponível"}
          </p>
        )}

        <div className={styles.containerQtd}>
          <MinusSquare className={styles.qtdMenos} onClick={() => decreaseItem(item.id)} />
          <span>{item.unidades}</span>
          <PlusSquare
            className={`${styles.qtdMais} ${limiteAtingido ? styles.qtdDesabilitada : ""}`}
            onClick={() => {
              if (limiteAtingido) return;
              increaseItem(item.id);
            }}
          />
        </div>
      </div>

      {/* PREÇO */}
      <div className={styles.containerPreco}>
        <Trash2 size={15} className={styles.remover} onClick={() => removeItemCart(item.id)} />
        <p className={styles.preco}>{formatarMoeda(item.preco * item.unidades)}</p>
      </div>
    </section>
  );
};
